import { render, staticRenderFns } from "./ProcesoComp.vue?vue&type=template&id=6d44d33a&"
var script = {}
import style0 from "./ProcesoComp.vue?vue&type=style&index=0&id=6d44d33a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports